import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import styles from './dashboard.module.scss';
import { KoCharts,  KoProgress, KoSkeleton,  KoTag, KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import BillableData from 'pages/reports/development/billableNonBillable';
import LeaveTaken from 'pages/reports/development/leavetaken';
import TimeLogged from 'pages/reports/development/timeLogged';
import ActualVsEstimated from 'pages/reports/development/actualVsEstimated';
import PRChart from 'pages/reports/development/PRChart';
import ScrumVelocityChart from 'pages/reports/development/velocityChart';
import PriorityDonutChart from 'pages/reports/development/priority';
import TechDebtWaterfallChart from 'pages/reports/development/techDebtWaterfallChart';
// import UtilizationDonutChart from 'pages/reports/development/utilizationDonutChart';
import BurndownChartWithColorBands from 'pages/reports/development/burndown';
import WorklogStatusStackedChart from 'pages/reports/development/worklogStatusStackedChart';
import { DashboardAPI } from './dashboard.service';
import { formatDate, getDateRange } from 'shared/utils';
import WorkflowStatusDonutChart from 'pages/reports/development/workflowStatusDonutChart';
import IssueTypeBarChart from 'pages/reports/development/issueTypeBarChart';
export default function MyView() {
  const [searchParams] = useSearchParams();
  const { workspaceId } = useParams();
  const seletedDate = searchParams.get('date');
  const seletedSprint = searchParams.get('sprint');
  const [estimatedVsActual, setEstimatedVsActual] = useState([]);
  const [loadingEstimatedVsActual, setLoadingEstimatedVsActual] = useState(false);
  const [leaveChartData, setLeaveChartData] = useState([]);
  const [loadingLeaveChart, setLoadingLeaveChart] = useState(false);
  const [, setUserWorkload] = useState([]);
  const [, setLoadingUserWorkload] = useState(false);
  const [dashboardCards, setDashboardCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState();
  const [loading, setLoading] = useState(false);
  const [priorityGraph, setPriorityGraph] = useState([]);
  const [issueTypeGraph, setIssueTypeGraph] = useState([]);
  const [workflowStatus, setWorkflowStatus] = useState([]);
  const [userStatus, setUserStatus] = useState([]);
  const [velocityOverview, setVelocityOverview] = useState([]);
  const [billableData, setBillableData] = useState([]);
  const [techDebt, setTechDebt] = useState([]);
  const [loggedTime, setLoggedTime ] = useState([]);
  const [burndownData, setBurndownData] = useState([]);
  const [pullRequestData, setPullRequestData] = useState([]);
  const [deliveryTimeline, setDeliveryTimeline] = useState([]);

  const [loadingPriority, setLoadingPriority] = useState(false);
  const [loadingIssueType, setLoadingIssueType] = useState(false);
  const [loadingWorkflow, setLoadingWorkflow] = useState(false);
  const [loadingUserStatus, setLoadingUserStatus] = useState(false);
  const [loadingVelocity, setLoadingVelocity] = useState(false);
  const [loadingBurndown, setLoadingBurndown] = useState(false);
  const [loadingBillable, setLoadingBillable] = useState(false);
  const [loadingTechDebt, setLoadingTechDebt] = useState(false);
  const [loadingLoggedTime, setLoadingLoggedTime] = useState(false);
  const [loadingPullRequest, setLoadingPullRequest] = useState(false);
  const [loadingDeliveryTimeline, setLoadingDeliveryTimeline] = useState(false);

  let query = {};
  if (seletedDate) {
    let date = getDateRange(seletedDate);
    query = { ...query, ...date };
  }
  if (seletedSprint && seletedSprint !== 'all') {
    query = { ...query, sprint: seletedSprint  };
  }


  useEffect(() => {
    setLoadingCards(true);
    Promise.all([
      DashboardAPI.getTeamsCount(workspaceId, query),
      DashboardAPI.getTotalTasks(workspaceId, query),
      DashboardAPI.getOverdueTasks(workspaceId, query),
      DashboardAPI.getTotalDocuments(workspaceId, query)
    ])
      .then(([teamsRes, tasksRes, overdueRes, docsRes]) => {
        const dynamicCards = [
          {
            label: 'Team in Space',
            icon: 'UsersFilled',
            arrow: 'ArrowLineUpFilled',
            description: 'All active workspace members',
            value: `${teamsRes?.usersCount ?? 0}`
          },
          {
            label: 'Total Tasks',
            icon: 'RevenueFilled',
            value: `${tasksRes?.ticketsCount?.totalTickets ?? 0}`,
            description: 'Total created project tasks',
            arrow: 'ArrowLineUpFilled'
          },
          {
            label: 'Task In Progress',
            icon: 'ClockFilled',
            value: `${tasksRes?.ticketsCount?.inTrack ?? 0}%`,
            description: 'Overall task in progress rate',
            arrow: 'ArrowLineUpFilled',
            progress: 30
          },
          {
            label: 'Task Completed',
            icon: 'ClockFilled',
            value: `${tasksRes?.ticketsCount?.completedTickets ?? 0}`,
            description: 'Overall task completion rate',
            arrow: 'ArrowLineUpFilled',
            progress: 30
          },
          {
            label: 'On Track',
            icon: 'IssueRisedTwoTone',
            value: `${tasksRes?.ticketsCount?.completedPercentage ?? 0}%`,
            description: 'Projects running on time',
            burnRate: '₹10 lakh/month',
            arrow: 'ArrowLineUpFilled'
          },
          {
            label: 'Overdue Tasks',
            icon: 'LineUpFilled',
            value: `${overdueRes?.overdueCount ?? 0}`,
            description: 'Total overdue project tasks',
            arrow: 'ArrowLineUpFilled',
            budget: '+₹2 lakh due delay'
          },
          {
            label: 'Total Documents',
            icon: 'Folder4Filled',
            value: `${docsRes?.filesCount ?? 0} Docs`,
            description: 'All uploaded workspace files',
            arrow: 'ArrowLineUpFilled',
            budget: '+₹2 lakh infra cost'
          }
          // {
          //   label: 'Latest Release',
          //   icon: 'PrdFilled',
          //   value: 'Version 1.0',
          //   description: 'Released 1 July 2025',
          //   arrow: 'ArrowLineUpFilled'
          // }
        ];

        setDashboardCards(dynamicCards);
      })
      .catch((err) => {
        console.error("Failed to load dashboard cards", err);
      })
      .finally(() => {
        setLoadingCards(false);
      });
  }, [seletedSprint, seletedDate]);


  useEffect(() => {
    setLoadingDeliveryTimeline(true);
    DashboardAPI.getDeliveryTimeline(workspaceId, query )
      .then((res) => setDeliveryTimeline(res || []))
      .catch(console.error)
      .finally(() => setLoadingDeliveryTimeline(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingEstimatedVsActual(true);
    DashboardAPI.getEstimatedVsActualTime(workspaceId, query)
      .then((res) => setEstimatedVsActual(res || []))
      .catch(console.error)
      .finally(() => setLoadingEstimatedVsActual(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoading(true);
    DashboardAPI.getDaysRemaining(seletedSprint, workspaceId, query)
      .then((res) => setDaysRemaining(res.sprintStatus || {}))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [seletedSprint, seletedDate]);


  

  useEffect(() => {
    setLoadingLeaveChart(true);
    DashboardAPI.getLeaveChart(workspaceId, query)
      .then((res) => setLeaveChartData(res || []))
      .catch(console.error)
      .finally(() => setLoadingLeaveChart(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingUserWorkload(true);
    DashboardAPI.getUserWorkload(workspaceId, query)
      .then((res) => setUserWorkload(res?.workload || []))
      .catch(console.error)
      .finally(() => setLoadingUserWorkload(false));
  }, [seletedSprint, seletedDate]);


  useEffect(() => {
    setLoadingPriority(true);
    DashboardAPI.getPriorityGraph(workspaceId, query)
      .then(res => setPriorityGraph(res?.priority || []))
      .catch(console.error)
      .finally(() => setLoadingPriority(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingIssueType(true);
    DashboardAPI.getIssueTypeGraph(workspaceId, query)
      .then(res => setIssueTypeGraph(res.issueTypes || []))
      .catch(console.error)
      .finally(() => setLoadingIssueType(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingWorkflow(true);
    DashboardAPI.getWorkflowStatus(workspaceId, query)
      .then(res => setWorkflowStatus(res.statusSummary || []))
      .catch(console.error)
      .finally(() => setLoadingWorkflow(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingUserStatus(true);
    DashboardAPI.getUserStatusBreakdown(workspaceId, query)
      .then(res => setUserStatus(res || []))
      .catch(console.error)
      .finally(() => setLoadingUserStatus(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingVelocity(true);
    DashboardAPI.getVelocityOverview(workspaceId, query)
      .then(res => setVelocityOverview(res || []))
      .catch(console.error)
      .finally(() => setLoadingVelocity(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingBillable(true);
    DashboardAPI.getBillableData(workspaceId, query)
      .then(res => setBillableData(res || []))
      .catch(console.error)
      .finally(() => setLoadingBillable(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingTechDebt(true);
    DashboardAPI.getTechDebtData(workspaceId, query)
      .then(res => setTechDebt(res || []))
      .catch(console.error)
      .finally(() => setLoadingTechDebt(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingLoggedTime(true);
    DashboardAPI.getLoggedTime(workspaceId, query)
      .then(res => setLoggedTime(res || []))
      .catch(console.error)
      .finally(() => setLoadingLoggedTime(false));
  }, [seletedSprint, seletedDate]);

  console.log(deliveryTimeline, loadingDeliveryTimeline, daysRemaining, loading );
  useEffect(() => {
    setLoadingBurndown(true);
    DashboardAPI.getBurndown(workspaceId, query)
      .then(res => setBurndownData(res || []))
      .catch(console.error)
      .finally(() => setLoadingBurndown(false));
  }, [seletedSprint, seletedDate]);

  useEffect(() => {
    setLoadingPullRequest(true);
    DashboardAPI.getPullRequest(workspaceId, query)
      .then(res => setPullRequestData(res || []))
      .catch(console.error)
      .finally(() => setLoadingPullRequest(false));
  }, [seletedSprint, seletedDate]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.contentBox}>
          {
            !loadingCards && dashboardCards.length > 0 && dashboardCards.map((i) => <div key={i} className={styles.card}>
              <div className={styles.icon}>
                <KoIcon name={i.icon} width={46} height={46} />
              </div>
              <div className={styles.mycontent}>
                <KoText className={styles.label} text={i.label} />
                <KoTitle level={1} className={styles.value} text={i.value} />
                <div className={styles.descriptionBox}>
                  <KoIcon name={i.arrow} width={16} height={16} />
                  <KoText className={styles.description} text={i.description} />
                </div>
              </div>
            </div>)
          }
          {
            loadingCards && [1, 2, 3, 4, 5, 6, 7].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
          }
        </div>
        <div className={styles.infoGraph}>
          <div className={styles.variancepipelineWrapper}>
            <div className={`${styles.varianceEstimated} variancepipelineWrapper`}>
              <KoTitle text={`Actual Time vs Estimated Time`} level={4} />
              {!loadingEstimatedVsActual && <KoCharts option={ActualVsEstimated(estimatedVsActual)} />}
              {loadingEstimatedVsActual && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
          </div>
          <div className={`${styles.scoreWrapper} mediumsize`}>
            <div className={styles.card}>
              <KoTitle text={`On the Radar`} level={4} />
              {!loadingPriority && <KoCharts option={PriorityDonutChart(priorityGraph)} />}
              {loadingPriority && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
          </div>
        </div>
        <div className={styles.infoGraph}>
          <div className={styles.billableWrapper}>
            <div className={styles.variancepipeline}>
              <div className={styles.variance}>
                <KoTitle text={`Delivery Timeline and Variance`} level={4} />
                <div className={styles.varianceBox}>
                  <div className={styles.date}>
                    <KoTitle level={5} text={formatDate(deliveryTimeline?.plannedEndDate,'MMM D, YYYY')} />
                    <KoText className={styles.label} text={'Planned End Date'} />
                  </div>
                  <div className={styles.date}>
                    <KoTitle level={5} text={formatDate(deliveryTimeline?.estimatedCompletion,'MMM D, YYYY')} />
                    <KoText className={styles.label} text={'Estimated Completion'} />
                  </div>
                  <div className={styles.date}>
                    <KoTag className={styles.tag} value={`${deliveryTimeline?.scheduleVarianceDays} days`} color={'red'} />
                    <KoText className={styles.label} text={'Schedule Variance'} />
                  </div>
                </div>
                <div className={styles.varianceProgress}>
                  <div className={styles.progress}>
                    <div className={styles.planned}>
                      <KoTitle level={5} text={`${deliveryTimeline?.planned || 0} Planned`} />
                      <KoTitle level={5} text={`${deliveryTimeline?.addedExtra || 0} + Logged extra`} />
                    </div>
                    <KoProgress className={styles.percentage} options={[{ value: deliveryTimeline?.addedExtra ? deliveryTimeline?.addedExtra : 0, count: deliveryTimeline?.planned ? deliveryTimeline?.planned : 0 }]} />
                    <div className={styles.actual}>
                      <KoText className={styles.label} text={'Planned vs Actual'} />
                    </div>
                  </div>
                </div>
              </div>
              {daysRemaining && <div className={styles.pipeline}>
                <KoTitle ellipsis={true} text={`Sprint: ${daysRemaining?.name}`} level={4} />
                <div className={styles.salesInfo}>
                  <KoTitle level={1} className={styles.value} text={`${daysRemaining?.totalDays}`} />
                  <KoTitle level={1} className={styles.value} text={`Total Days`} />
                  <div className={styles.salesproposal}>
                    <KoText className={styles.label} text={`Days Completed: ${daysRemaining?.completedDays}`} />
                    <KoText className={styles.label} text={`Days Remaining(s): ${daysRemaining?.remainingDays > 0 ? daysRemaining?.remainingDays : 0}`} />
                  </div>
                </div>
              </div>}
            </div>
            <div className={`${styles.billableNonBillable} billable`}>
              <KoTitle text={`Billable vs Non Billable `} level={4} />
              {!loadingBillable &&  <KoCharts option={BillableData(billableData)} />}
              {loadingBillable && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
          </div>
          <div className={`${styles.scoreWrapper} mediumsize`}>
            <div className={styles.card}>
              <KoTitle text={`Author-wise Open PRs`} level={4} />
              {!loadingPullRequest && <KoCharts option={PRChart(pullRequestData)} />}
              {loadingPullRequest && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
            <div className={styles.card}>
              <KoTitle text={`Tech Debt: Added vs Resolved`} level={4} />
              {!loadingTechDebt &&  <KoCharts option={TechDebtWaterfallChart(techDebt)} />}
              {loadingTechDebt && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
          </div>
        </div>
        <div className={styles.columntwo}>
          <div className={`${styles.card} workload`}>
            <KoTitle text={`Status-wise Task Summary`} level={4} />
            {!loadingWorkflow && <KoCharts option={WorkflowStatusDonutChart(workflowStatus)} />}
            {loadingWorkflow && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
          <div className={`${styles.card} workload`}>
            <KoTitle text={`Type-wise Ticket Breakdown`} level={4} />
            {!loadingIssueType && <KoCharts option={IssueTypeBarChart(issueTypeGraph)} />}
            {loadingIssueType && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
        </div>
        <div className={styles.infoGraph}>
          <div className={`${styles.scoreWrapper} breakdown`}>
            <div className={styles.card}>
              <KoTitle text={`Logged Time Breakdown`} level={4} />
              {!loadingLoggedTime &&  <KoCharts option={TimeLogged(loggedTime)} />}
              {loadingLoggedTime && <KoSkeleton.Node active={true}>
                <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
              </KoSkeleton.Node>}
            </div>
          </div>
          <div className={`${styles.leaveTaken} mediumsize`}>
            <KoTitle text={`Leave Trend`} level={4} />
            {!loadingLeaveChart && <KoCharts option={LeaveTaken(leaveChartData?.leaves, leaveChartData?.weeks)} />}
            {loadingLeaveChart && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
        </div>
        <div className={`${styles.columnone} velocityFull`}>
          <div className={styles.card}>
            <KoTitle text={`Engineering Status Velocity`} level={4} />
            {!loadingVelocity && <KoCharts option={ScrumVelocityChart(velocityOverview)} />}
            {loadingVelocity && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
        </div>
        {/* <div className={styles.columntwo}>
          <div className={`${styles.card} workload`}>
            <KoTitle text={`Workload Load Balance`} level={4} />
            {!loadingUserWorkload && <KoCharts option={WorkloadPieChart(userWorkload)} />}
            {loadingUserWorkload && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
          <div className={`${styles.card} workload`}>
            <KoTitle text={`Recent Activity`} level={4} />
            {!loadingRecentTickets && <div className={styles.recentTickets}>
              <KoTable rowKey={'uid'}
                data={{ columns: PRO_ITEMS_COLUMNS, rows: recentTickets }}
                maxHeight={55} /></div>}
            {loadingRecentTickets && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
        </div> */}
        <div className={`${styles.wideLeft} mediumsize`}>
          <div className={styles.card}>
            <KoTitle text={`Team Member Status Breakdown`} level={4} />
            {!loadingUserStatus && <KoCharts option={WorklogStatusStackedChart(userStatus)} />}
            {loadingUserStatus && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
          <div className={styles.card}>
            <KoTitle text={`Burndown`} level={4} className={styles.headerH4} />
            { !loadingBurndown && <KoCharts option={BurndownChartWithColorBands(burndownData)} />}
            {loadingBurndown && <KoSkeleton.Node active={true}>
              <KoIcon name="ChartOutlined" color={'var(--palette-gray-5)'} width={100} height={100} />
            </KoSkeleton.Node>}
          </div>
        </div>
      </div>
    </>
  );
}
